"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeparatorToolbarItemTemplateCreator = void 0;
var tslib_1 = require("tslib");
var dxt_theme_css_classes_1 = require("../../../../dxt-utils/dxt-utils/dxt-theme-css-classes");
var base_types_1 = require("./base-types");
var SeparatorToolbarItemTemplateCreator = (function (_super) {
    tslib_1.__extends(SeparatorToolbarItemTemplateCreator, _super);
    function SeparatorToolbarItemTemplateCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeparatorToolbarItemTemplateCreator.prototype.createTemplate = function () {
        var result = _super.prototype.createTemplate.call(this);
        result.disabled = true;
        result.dxIsSeparator = true;
        result.template = function () {
            var element = document.createElement('div');
            element.classList.add(SeparatorToolbarItemTemplateCreator.SeparatorClassName);
            element.classList.add(dxt_theme_css_classes_1.DxtThemeCssClasses.BorderColor);
            return element;
        };
        return result;
    };
    SeparatorToolbarItemTemplateCreator.SeparatorClassName = 'dx-r-separator';
    return SeparatorToolbarItemTemplateCreator;
}(base_types_1.ToolbarItemTemplateCreator));
exports.SeparatorToolbarItemTemplateCreator = SeparatorToolbarItemTemplateCreator;
